import { Theme } from '@mui/material';
export const SUPERVISOR_TAG = 'supervisor';

export const SUPERVISOR_REVIEW_TAB_OPTIONS = ['annotator1', 'annotator2', 'conflicts', 'resolved'];

export const SUPERVISOR_COMPLETED_STATUS_STR = 'supervisor_completed';
export const COMPLETED_STATUS_STR = 'completed';

export const STATUS_CHIP_BACKGROUND_MAPPING = (theme: Theme) => {
  return {
    finalized: theme.palette.success.main,
    pending: theme.palette.primary.main,
    draft: theme.palette.grey[500],
    conflicts_pending: theme.palette.error.main,
    supervisor_completed: theme.palette.success.main,
    completed: theme.palette.success.main,
    active: theme.palette.primary.main,
  };
};

export const STATUS_CHIP_TEXT_COLOR_MAPPING = (theme: Theme) => {
  return {
    finalized: theme.palette.success.contrastText,
    pending: theme.palette.primary.contrastText,
    draft: theme.palette.primary.contrastText,
    conflicts_pending: theme.palette.error.contrastText,
    supervisor_completed: theme.palette.success.contrastText,
    completed: theme.palette.success.contrastText,
    active: theme.palette.primary.contrastText,
  };
};
